import { render, staticRenderFns } from "./InfoTransacaoPix.vue?vue&type=template&id=a53e5832&scoped=true"
import script from "./InfoTransacaoPix.vue?vue&type=script&lang=js"
export * from "./InfoTransacaoPix.vue?vue&type=script&lang=js"
import style0 from "./InfoTransacaoPix.vue?vue&type=style&index=0&id=a53e5832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53e5832",
  null
  
)

export default component.exports